(function () {
  function cleanPhone(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function whatsappUrl(phone, text) {
    return 'https://api.whatsapp.com/send?phone=' + encodeURIComponent(cleanPhone(phone)) + '&text=' + encodeURIComponent(text);
  }

  function track(action, source, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ajax_landing_interaction',
      ajax_action: action || 'interaction',
      ajax_source: source || 'unknown',
      ajax_detail: detail || ''
    });
  }

  function setupWhatsapp(scope) {
    (scope || document).querySelectorAll('[data-ajax-whatsapp]').forEach(function (link) {
      if (link.getAttribute('href') && link.getAttribute('href') !== '#') return;
      var phone = link.getAttribute('data-phone');
      var message = link.getAttribute('data-message') || 'Hola, vi los sistemas Ajax en VIGILANTEC y me gustaría una cotización.';
      link.setAttribute('href', whatsappUrl(phone, message));
    });
  }

  function setupEcosystem(section) {
    var catalog = section.querySelector('[data-ajax-catalog]');
    if (!catalog) return;

    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-ajax-category-button]'));
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-ajax-catalog-item]'));
    var title = section.querySelector('[data-ajax-catalog-title]');
    var empty = section.querySelector('[data-ajax-category-empty]');
    var grid = section.querySelector('[data-ajax-catalog-grid]');
    var close = section.querySelector('[data-ajax-catalog-close]');

    function openCategory(button) {
      var category = button.getAttribute('data-category');
      var categoryTitle = button.getAttribute('data-category-title') || 'Equipos Ajax';
      var visibleItems = [];

      buttons.forEach(function (other) {
        var active = other === button;
        other.setAttribute('aria-expanded', active ? 'true' : 'false');
        other.closest('.ajax-product-card')?.classList.toggle('is-active', active);
      });

      items.forEach(function (item) {
        var show = item.getAttribute('data-category') === category;
        item.hidden = !show;
        if (show) visibleItems.push(item);
      });

      visibleItems.sort(function (a, b) {
        return Number(a.getAttribute('data-order') || 9999) - Number(b.getAttribute('data-order') || 9999);
      }).forEach(function (item) {
        if (grid) grid.appendChild(item);
      });

      if (title) title.textContent = categoryTitle;
      if (grid) grid.hidden = visibleItems.length === 0;
      if (empty) empty.hidden = visibleItems.length !== 0;
      catalog.hidden = false;
      track('catalog_category', 'ecosystem', categoryTitle);

      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      catalog.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () { openCategory(button); });
    });

    if (close) {
      close.addEventListener('click', function () {
        catalog.hidden = true;
        buttons.forEach(function (button) {
          button.setAttribute('aria-expanded', 'false');
          button.closest('.ajax-product-card')?.classList.remove('is-active');
        });
      });
    }

    section.querySelectorAll('[data-ajax-modal-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        var modal = document.getElementById(button.getAttribute('data-ajax-modal-open'));
        if (!modal) return;
        track('product_open', 'ecosystem', modal.querySelector('h3')?.textContent || '');
        if (typeof modal.showModal === 'function') modal.showModal();
        else modal.setAttribute('open', '');
      });
    });

    section.querySelectorAll('[data-ajax-product-modal]').forEach(function (modal) {
      modal.querySelectorAll('[data-ajax-modal-close]').forEach(function (button) {
        button.addEventListener('click', function () { modal.close(); });
      });
      modal.addEventListener('click', function (event) {
        if (event.target === modal) modal.close();
      });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-ajax-configurator]').forEach(function (form) {
      if (form.dataset.ajaxReady === 'true') return;
      form.dataset.ajaxReady = 'true';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var phone = form.getAttribute('data-whatsapp-number');
        var property = form.querySelector('input[name="ajax-property"]:checked');
        var access = form.querySelector('input[name="ajax-access"]:checked');
        var interests = Array.prototype.slice.call(form.querySelectorAll('input[name="ajax-interest"]:checked')).map(function (input) {
          return input.value;
        });
        var intro = form.getAttribute('data-message-intro') || 'Hola, vi los sistemas Ajax en VIGILANTEC y quiero una cotización.';
        var lines = [intro, '', 'Tipo de propiedad: ' + (property ? property.value : 'No indicado'), 'Accesos a proteger: ' + (access ? access.value : 'No indicado')];
        if (interests.length) lines.push('Me interesa: ' + interests.join(', '));
        lines.push('', '¿Me pueden ayudar a seleccionar los equipos adecuados?');
        track('whatsapp', form.getAttribute('data-ajax-source') || 'configurator', interests.join(', '));
        window.open(whatsappUrl(phone, lines.join('\n')), '_blank', 'noopener');
      });
    });

    (root || document).querySelectorAll('[data-ajax-track="whatsapp"]').forEach(function (link) {
      if (link.dataset.ajaxTrackReady === 'true') return;
      link.dataset.ajaxTrackReady = 'true';
      link.addEventListener('click', function () {
        track('whatsapp', link.getAttribute('data-ajax-source') || 'cta', link.getAttribute('data-ajax-detail') || '');
      });
    });

    setupWhatsapp(root || document);
    (root || document).querySelectorAll('[data-ajax-ecosystem]').forEach(function (section) {
      if (section.dataset.ajaxReady === 'true') return;
      section.dataset.ajaxReady = 'true';
      setupEcosystem(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();